(function () {
    'use strict';

    angular.module("imApp").factory("operationsService", ['$ihttp', function ($ihttp) {
        let service = {
            getOperations: function (parms) {
                return $ihttp.post({
                    method: 2647,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
